import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Native-Angular port of the AngularJS `ft-guest-card` directive
 * (account-v1/.../people/guestCard.directive.js + guestCard.html). Two modes:
 * 'directory' and 'feedback'. Selector is `app-guest-card` to avoid clashing
 * with the still-registered AngularJS `ft-guest-card` during the transition;
 * rename to `ft-guest-card` once the AngularJS directory/feedback are removed.
 */
@Component({
    // Renamed from `app-guest-card` to `ft-guest-card` (M6.2) once the AngularJS
    // `ft-guest-card` directive was deregistered (M6.1). Matches the legacy
    // selector so consumers don't have to know the framework boundary.
    selector: 'ft-guest-card',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './guest-card.component.html',
    standalone: false,
})
export class GuestCardComponent {
  @Input() type: 'directory' | 'feedback' = 'directory';
  @Input() guest: any;
  @Output() selected = new EventEmitter<any>();

  select(guest: any): void {
    this.selected.emit(guest);
  }
}
